
import http from '@/fetch';
// 不使用这种导入是因为eslint会检测到依赖循环,取全局变量window.$vm.$http
const city = {
  state: {
    data: { list: [], obj: {} },
  },
  getters: {

  },
  mutations: {

  },
  actions: {
    // 获取省市区
    async getCityData(context) {
      if (!context.state.data.list.length) {
        const res = await http.get('/api/area/list');
        if (res && res.success) {
          const obj = {};
          const format = (list) => {
            const formatList = [];
            list.forEach(ele => {
              const item = {
                label: ele.areaName,
                value: ele.areaCode,
              };
              obj[ele.areaCode] = ele.areaName;
              if (ele.subList) {
                item.children = format(ele.subList);
              }
              formatList.push(item);
            });
            return formatList;
          };
          context.state.data = { list: format(res.data), obj };
        }
      }
      return context.state.data;
    },
  },
};

export default city;
